import React, { useState } from 'react';
import { Form, Select, message } from 'antd';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { ApplicationState } from '../../../store';
import mask from '../../../utils/mask';
import {
  IClienteTransportadoraResponse,
  SelectClientesTransportadorasServices,
} from './service/selectClientService';
import TextFilter from '../../../components/TextFilter';

export const SelectParceirosTransportadoras: React.FC = () => {
  const { Option } = Select;
  const parceiros = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const [response, setResponse] = useState<IClienteTransportadoraResponse | undefined>(undefined);

  function handleListClientsRequest(): void {
    if (parceiros.length === 0) {
      message.warning('Selecione um parceiro para ter acesso a lista de clientes!');
      return;
    }

    if (localStorage.getItem(`responseClientesFilter${window.location.pathname}`)) {
      const transportadorasFilter = JSON.parse(
        localStorage.getItem(`responseClientesFilter${window.location.pathname}`) || '{}'
      );
      setResponse(transportadorasFilter);
      return;
    }

    try {
      SelectClientesTransportadorasServices.getClientesTransportadoras(parceiros).then((res) => {
        setResponse(res.data);
        localStorage.setItem(
          `responseClientesFilter${window.location.pathname}`,
          JSON.stringify(res.data)
        );
      });
    } catch (error: any) {
      if (error.response.data.Error)
        Swal.fire({
          title: error.response.data.Error,
          html: '',
          icon: 'warning',
          showConfirmButton: false,
        });
      else
        Swal.fire({
          title: 'Não foi possivel carregar os clientes parceiros, por favor tente novamente!',
          html: '',
          icon: 'warning',
          showConfirmButton: false,
        });
    }
  }

  return (
    <Form.Item label={<TextFilter>Parceiro</TextFilter>} name="codParceiro">
      <Select
        showSearch
        style={{ width: '100%' }}
        filterOption={(inputValue, element) =>
          element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
        }
        onFocus={handleListClientsRequest}
        placeholder="Selecione um parceiro"
      >
        {response ? (
          response?.clientes?.map((inscData) => (
            <Option className="optionselect" value={inscData.codParc} key={inscData.codParc}>
              {mask('camelCase', inscData.nome)} - {inscData.codParc}
              <br />
              CNPJ/CPF: {mask('cpfCnpj', inscData.cnpjCpf)} <br />
              Inscrição estadual: {inscData.identidade} <br />
              <hr />
            </Option>
          ))
        ) : (
          <Option value={-1}>Carregando...</Option>
        )}
      </Select>
    </Form.Item>
  );
};
